"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.sort");
var _memberManage = require("@/api/_homeCloudPlatform/member/memberManage.js");
var _commodityManage = require("@/api/_homeCloudPlatform/mall/commodityManage.js");
var _group = require("@/api/_homeCloudPlatform/group/group.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _Address = _interopRequireDefault(require("@/components/Address"));
var _vueQrcodeComponent = _interopRequireDefault(require("vue-qrcode-component"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {
  // 状态: '1'
  role: '2',
  group: '',
  role_id: {
    role_type: ''
  },
  user_address: []
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Address: _Address.default,
    VueQRCodeComponent: _vueQrcodeComponent.default
  },
  computed: {
    rule1: function rule1() {
      return {
        groupRule: [{
          required: this.formModel.role === '2' && !this.formModel.group,
          message: '请选择合作机构',
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    // 切换角色时不跳提醒
    'formModel.role': {
      handler: function handler(val) {
        var _this = this;
        this.$nextTick(function () {
          _this.$refs['Form'].clearValidate('groupRule');
        });
      }
    },
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    },
    dialogVisible: {
      handler: function handler(flag) {
        if (!flag) this.activeName = '1';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      tagsList: [],
      listLoading: true,
      treatmentRecordsLoading: true,
      deviceAndDiscInfoLoading: true,
      // 预设排序,依创建时间递减
      defaultOrdering: '-created_at',
      defaultTreatmentRecordsOrdering: '-begin_time',
      defaultStoreTreatmentRecordsOrdering: '-begin_time',
      defaultUserQuotaListOrdering: '-start_time',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20,
        login_status: '',
        // 角色
        'role_id.role_type': ''
      },
      dialogVisible: false,
      dialogType: 'view',
      groupOptions: [],
      activeName: '1',
      // 状态选项
      statusOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 0,
        display_name: '正常'
      }, {
        key: 1,
        display_name: '停权'
      }],
      // 调理纪录
      treatmentRecordsStatusOptions: [{
        key: 'abort',
        display_name: '异常'
      }, {
        key: 'normal',
        display_name: '正常'
      }],
      // 角色选项
      roleOptions: [{
        key: 'all',
        display_name: '全部'
      }, {
        key: 1,
        display_name: '普通会员'
      }, {
        key: 2,
        display_name: '公司员工'
      }, {
        key: 3,
        display_name: '合作机构负责人'
      }
      // { key: 4, display_name: '事业合伙人' }
      ],
      // 来源选项
      sourceOptions: [{
        key: 0,
        display_name: '内建User'
      }, {
        key: 1,
        display_name: '小程序'
      }, {
        key: 2,
        display_name: 'Android'
      }, {
        key: 3,
        display_name: 'iOS'
      }],
      //  性别
      sexOptions: [{
        key: 0,
        display_name: '男'
      }, {
        key: 1,
        display_name: '女'
      }, {
        key: 2,
        display_name: '保密'
      }],
      // 是否
      yesOrNoOption: [{
        key: false,
        display_name: '否'
      }, {
        key: true,
        display_name: '是'
      }],
      // 是否
      deviceType: [{
        key: 1,
        display_name: '设备'
      }, {
        key: 2,
        display_name: '控释盘'
      }],
      quotaModule: [{
        key: 'openHomePackage',
        display_name: '打开到家产品包'
      }, {
        key: 'openStorePackage',
        display_name: '打开到店产品包'
      }, {
        key: 'returnHomePackage',
        display_name: '退还到家产品包'
      }, {
        key: 'returnStorePackage',
        display_name: '退还到店产品包'
      }, {
        key: 'createOnlineOrder',
        display_name: '订单使用积分'
      }, {
        key: 'returnOnlineOrder',
        display_name: '退还下单使用积分'
      }, {
        key: 'adminBackendChange',
        display_name: '管理员变更积分'
      }],
      deviceAndDiscInfo: [],
      // 设备和控释盘信息
      treatmentRecords: [],
      // 调理纪录
      dialog_tableData3: [],
      inputVisible: false,
      inputValue: '',
      isSignatureFormShow: false,
      deviceAndDiscInfoQuery: {
        page: 1,
        page_size: 10
      },
      treatmentRecordsQuery: {
        page: 1,
        page_size: 10
      },
      storeTreatmentRecordsQuery: {
        page: 1,
        page_size: 10
      },
      userQuotaListQuery: {
        page: 1,
        page_size: 10
      },
      userQuotaList: [],
      storeTreatmentRecordsLoading: false,
      storeTreatmentRecords: [],
      customerRecordTypeObj: {
        true: '店铺',
        false: '外部引流'
      }
    };
  },
  created: function created() {
    this.handleSort();
    this.getList();
    // this.getGroupList()
    this.getTagsList();
  },
  methods: {
    checkPermission: _permission.default,
    // 标籤清单
    getTagsList: function getTagsList() {
      var _this2 = this;
      (0, _commodityManage.getTagsList)().then(function (response) {
        _this2.tagsList = response.results.filter(function (item) {
          return item.type === 1;
        }) || [];
      });
    },
    getList: function getList(e) {
      var _this3 = this;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      this.listLoading = true;
      (0, _memberManage.getUsersList)(this.handleQuery()).then(function (response) {
        _this3.tableData = response || {};
        _this3.listLoading = false;
      });
    },
    // 取得设备讯息清单
    getDeviceAndDiscInfoList: function getDeviceAndDiscInfoList() {
      var _this4 = this;
      this.deviceAndDiscInfoLoading = true;
      (0, _memberManage.getPlanDeviceList)({
        page: this.deviceAndDiscInfoQuery.page,
        page_size: this.deviceAndDiscInfoQuery.page_size,
        ordering: this.deviceAndDiscInfoQuery.ordering,
        account: this.formModel.account
      }).then(function (res) {
        _this4.deviceAndDiscInfo = res;
        _this4.deviceAndDiscInfoLoading = false;
      });
    },
    // 取得调理纪录
    getTreatmentRecordsList: function getTreatmentRecordsList() {
      var _this5 = this;
      this.treatmentRecordsLoading = true;
      (0, _memberManage.getTreatmentRecordsList)({
        page: this.treatmentRecordsQuery.page,
        page_size: this.treatmentRecordsQuery.page_size,
        ordering: this.treatmentRecordsQuery.ordering,
        home_account: this.formModel.account
      }).then(function (res) {
        _this5.treatmentRecords = res;
        _this5.treatmentRecordsLoading = false;
      });
    },
    // 取得调理纪录
    getStoreTreatmentRecord: function getStoreTreatmentRecord() {
      var _this6 = this;
      this.storeTreatmentRecordsLoading = true;
      (0, _group.getStoreTreatmentRecord)({
        page: this.storeTreatmentRecordsQuery.page,
        page_size: this.storeTreatmentRecordsQuery.page_size,
        ordering: this.storeTreatmentRecordsQuery.ordering,
        user: this.formModel.id
      }).then(function (res) {
        _this6.storeTreatmentRecords = res;
        _this6.storeTreatmentRecordsLoading = false;
      });
    },
    // 取得会员积分纪录
    getUsersQuota: function getUsersQuota() {
      var _this7 = this;
      this.listLoading = true;
      (0, _memberManage.getUsersQuota)({
        page: this.userQuotaListQuery.page,
        page_size: this.userQuotaListQuery.page_size,
        ordering: this.userQuotaListQuery.ordering,
        user_account: this.formModel.account
      }).then(function (res) {
        _this7.userQuotaList = res;
        _this7.listLoading = false;
      });
    },
    handleView: function handleView(scope) {
      var _this8 = this;
      this.formModel = this.handleRowData(scope.row);
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this8.$refs['Form'].clearValidate();
      });
      this.reset();
    },
    handleEdit: function handleEdit(scope) {
      var _this9 = this;
      this.formModel = this.handleRowData(scope.row);
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this9.$refs['Form'].clearValidate();
      });
      this.reset();
    },
    reset: function reset() {
      this.deviceAndDiscInfoQuery = {
        page: 1,
        page_size: 10
      };
      // 表格sort还原
      var _this$handleSort = this.handleSort(),
        prop = _this$handleSort.prop,
        order = _this$handleSort.order;
      if (this.$refs.deviceAndDiscInfoTable) this.$refs.deviceAndDiscInfoTable.sort(prop, order);
      if (this.$refs.treatmentRecordsTable) this.$refs.treatmentRecordsTable.sort('begin_time', '');
    },
    handleRowData: function handleRowData(data) {
      // Tag处理
      data.tag = [];
      data.tags.forEach(function (item) {
        data.tag.push(item.name);
      });
      return JSON.parse(JSON.stringify(data));
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(form) {
        var _this10 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this10.dialogType === 'edit';
                  if (isEdit) {
                    var _this10$formModel = _this10.formModel,
                      id = _this10$formModel.id,
                      tag = _this10$formModel.tag,
                      login_status = _this10$formModel.login_status,
                      withdraw_bank = _this10$formModel.withdraw_bank,
                      withdraw_account = _this10$formModel.withdraw_account,
                      withdraw_bank_account = _this10$formModel.withdraw_bank_account,
                      withdraw_bank_branch = _this10$formModel.withdraw_bank_branch,
                      withdraw_status = _this10$formModel.withdraw_status;
                    var role_id = _this10.formModel.role_id.role_type;
                    var params = {
                      login_status: login_status,
                      tags: function () {
                        var results = [];
                        tag.forEach(function (item) {
                          results.push({
                            name: item,
                            type: 1
                          });
                        });
                        return results;
                      }(),
                      role_id: role_id,
                      withdraw_bank: withdraw_bank,
                      withdraw_account: withdraw_account,
                      withdraw_bank_account: withdraw_bank_account,
                      withdraw_bank_branch: withdraw_bank_branch,
                      withdraw_status: withdraw_status
                    };
                    (0, _memberManage.updateUser)(id, params).then(function (res) {
                      _this10.getList();
                      _this10.dialogVisible = false;
                      _this10.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handleClick: function handleClick(tab, event) {
      if (this.activeName === 'deviceAndDiscInfo') {
        this.getDeviceAndDiscInfoList();
      }
      if (this.activeName === 'treatmentRecords') {
        this.getTreatmentRecordsList();
      }
      if (this.activeName === 'userQuota') {
        this.getUsersQuota();
      }
      if (this.activeName === 'storeTreatmentRecords') {
        this.getStoreTreatmentRecord();
      }
    },
    // --- tag start ---
    showInput: function showInput() {
      var _this11 = this;
      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this11.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        var obj = {
          name: inputValue
        };
        if (!this.tagsList.filter(function (item) {
          return item.name === inputValue;
        }).length) {
          this.tagsList.push(obj);
          this.formModel.tag.push(inputValue);
          this.inputVisible = false;
          this.inputValue = '';
        } else {
          this.$message({
            message: '标签已存在',
            type: 'warning'
          });
        }
      }
    },
    // --- tag end ---
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size,
        ordering: this.listQuery.ordering
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      // 状态选项参数处理
      if (query.login_status === '' || query.login_status === 'all') {
        query.login_status = function () {
          return;
        }();
      }
      // 角色
      if (query['role_id.role_type'] === '' || query['role_id.role_type'] === 'all') {
        query['role_id.role_type'] = function () {
          return;
        }();
      }
      return query;
    },
    handleSort: function handleSort(column) {
      // 初始化处理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        this.listQuery.page = 1;
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    },
    // 调理纪录排序
    deviceAndDiscInfoSort: function deviceAndDiscInfoSort(column) {
      // 初始化处理
      if (!column) {
        this.deviceAndDiscInfoQuery.ordering = this.deviceAndDiscInfoQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        // 订单标号特殊处理
        if (column.prop == 'online_order_order_no') {
          column.prop = 'online_order__order_no';
        }
        this.deviceAndDiscInfoQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getDeviceAndDiscInfoList();
      }
    },
    // 调理纪录排序
    treatmentRecordsSort: function treatmentRecordsSort(column) {
      // 初始化处理
      if (!column) {
        this.treatmentRecordsQuery.ordering = this.treatmentRecordsQuery.ordering || this.defaultTreatmentRecordsOrdering;
        return {
          prop: this.defaultTreatmentRecordsOrdering.indexOf('-') !== -1 ? this.defaultTreatmentRecordsOrdering.split('-')[1] : this.defaultTreatmentRecordsOrdering,
          order: this.defaultTreatmentRecordsOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        // 订单标号特殊处理
        // if(column.prop == 'online_order_order_no'){ column.prop = 'online_order__order_no' }
        this.treatmentRecordsQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultTreatmentRecordsOrdering;
        this.getTreatmentRecordsList();
      }
    },
    // 店鋪调理纪录排序
    storeTreatmentRecordsSort: function storeTreatmentRecordsSort(column) {
      // 初始化处理
      if (!column) {
        this.storeTreatmentRecordsQuery.ordering = this.storeTreatmentRecordsQuery.ordering || this.defaultStoreTreatmentRecordsOrdering;
        return {
          prop: this.defaultStoreTreatmentRecordsOrdering.indexOf('-') !== -1 ? this.defaultStoreTreatmentRecordsOrdering.split('-')[1] : this.defaultStoreTreatmentRecordsOrdering,
          order: this.defaultStoreTreatmentRecordsOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        // 订单标号特殊处理
        // if(column.prop == 'online_order_order_no'){ column.prop = 'online_order__order_no' }
        this.storeTreatmentRecordsQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultStoreTreatmentRecordsOrdering;
        this.getStoreTreatmentRecord();
      }
    },
    // 会员积分排序
    userQuotaListSort: function userQuotaListSort(column) {
      // 初始化处理
      if (!column) {
        this.userQuotaListQuery.ordering = this.userQuotaListQuery.ordering || this.defaultUserQuotaListOrdering;
        return {
          prop: this.defaultUserQuotaListOrdering.indexOf('-') !== -1 ? this.defaultUserQuotaListOrdering.split('-')[1] : this.defaultUserQuotaListOrdering,
          order: this.defaultUserQuotaListOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 点击排序
      else {
        // 订单标号特殊处理
        // if(column.prop == 'online_order_order_no'){ column.prop = 'online_order__order_no' }
        this.userQuotaListQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultUserQuotaListOrdering;
        this.getUsersQuota();
      }
    },
    timeHandler: function timeHandler(data) {
      return data.split('T')[0] + ' ' + data.split('T')[1].replace('Z', '');
    },
    downloadQrCode: function downloadQrCode() {
      var canvasImage = this.$refs.qrcode.getElementsByTagName('canvas')[0].toDataURL('image/png');
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = 'qrcode.png';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };
      xhr.open('GET', canvasImage);
      xhr.send();
    }
  }
};